import { useGetAthletes } from 'api';
import { Athlete } from 'oas';
import * as React from 'react';
import { athleteInActivitySorter } from './athlete-in-activity-sorter';
import { useGetMappedAthletes } from './use-get-mapped-athletes';

export const useGetUnmappedAthletes = (activityId: string): Athlete[] | undefined => {
    const { data: athletes } = useGetAthletes();
    const mappedAthletes = useGetMappedAthletes(activityId);

    return React.useMemo(() => {
        if (athletes && mappedAthletes) {
            const mappedAthleteIds: string[] = mappedAthletes.reduce(
                (ids, athlete) => [...ids, athlete.id],
                [] as string[],
            );

            return athletes.filter((athlete) => !mappedAthleteIds.includes(athlete.id)).sort(athleteInActivitySorter);
        }
    }, [athletes, mappedAthletes]);
};
